import * as React from 'react';
import { Grid, Rating as RatingMui} from '@mui/material';
import { Icon, Text } from '.';
import { textsize } from '../services/app.service';

interface Props {
  id?: string;
  name: string;
  label?: string;
  value: number;
  max?: number;
  size?: textsize;
  sx?: any;
  selectedOnly?: boolean;
  readOnly?: boolean;
  disableMargin?: boolean;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
                    
}

export const InputRating: React.FunctionComponent<Props> = (props) => {
  const [value, setValue] = React.useState(0);
  const onChange = (e: React.SyntheticEvent<Element, Event>, newValue: number|null) => { 
    props.onChange?.(props.name, newValue?.toString()||'0');
    setValue(newValue || 0);
  }

  return (
    <Grid id={props.id || props.name} mt={props.disableMargin? 0 : 2} mb={props.disableMargin? 0: 3}>
      <Text label={props.label} size='small' color='text.secondary' />
      <RatingMui
        value={value || props.value}
        max={props.max || 5}
        sx={{...props.sx}}
        icon={<Icon name='star_icon' color='primary.light' size={props.size || 'small'} />} 
        emptyIcon={<Icon name='star_icon' color='background.paper' size={props.size || 'small'} />} 
        highlightSelectedOnly={props.selectedOnly}
        readOnly = {props.readOnly}
        onChange = {onChange}
      /> 
      <Text label={props.error} size='small' color='red' />
    </Grid>
  )
}


